import { Password, TextField } from '@boltenergy-be/design-system'
import { useStoreSelector } from 'hooks/store'
import { useTranslation } from 'react-i18next'

import styles from './LoginDetails.module.scss'
import { routes } from 'types/routes'
import Link from 'components/link/Link'
import { UserTypes } from 'store/auth/types'
import { useGetLanguage } from 'hooks/use-get-language'

const LoginDetails = () => {
  // Redux
  const { contact } = useStoreSelector((store) => store.contact)
  const { userType } = useStoreSelector((store) => store.auth)

  // i18n
  const { t } = useTranslation('auth')
  const language = useGetLanguage()

  return (
    <section className={styles.container}>
      <TextField label={t(($) => $.fields.email)} type="email" readonly={contact?.email} />
      <Password {...{ language }} label={t(($) => $.fields.password)} readonly="••••••••••••" />
      {userType === UserTypes.CUSTOMER && (
        <Link className={styles.button} variant="secondary" href={routes.USER_LOGIN_DETAILS_EDIT} representation="button">
          {t(($) => $.titles.resetPassword)}
        </Link>
      )}
    </section>
  )
}

export default LoginDetails
